// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"a474c998","239":"c3a0f34f","361":"8b1e608a","455":"16e726ed","977":"30bd5a12"}[chunkId] + ".chunk.js";
};